import { etiquetaMetodosPago, type MetodoPago } from '@barbones/shared';
import { cn } from '@/lib/utils';

/** Cómo pagó el cliente (Efectivo, Transferencia, Tarjeta o varios), en la esquina del bloque de la cita. */
export function EtiquetaPago({ metodos, compacta = false, className }: { metodos?: MetodoPago[]; compacta?: boolean; className?: string }) {
  if (!metodos?.length) return null;
  const { larga, corta } = etiquetaMetodosPago(metodos);
  return (
    <span title={larga} className={cn('shrink-0 rounded bg-surface/70 px-1 text-[10.5px] font-medium leading-4 text-foreground-muted', className)}>
      {compacta ? corta : larga}
    </span>
  );
}
